import { render, staticRenderFns } from "./lt-priority.vue?vue&type=template&id=29eccbb0&scoped=true&"
import script from "./lt-priority.vue?vue&type=script&lang=js&"
export * from "./lt-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eccbb0",
  null
  
)

export default component.exports